import { lazy } from "react";

export { SURVEY_EDITOR_PATH } from "./survey-editor-path";
export const SurveyEditorPage = lazy(() => import("./survey-editor"));

export { ToSurveyEditor } from "./to-survey-editor";
